import { render, staticRenderFns } from "./ChecklistAwardOngoingSurveyView.vue?vue&type=template&id=096649bc&"
import script from "./ChecklistAwardOngoingSurveyView.vue?vue&type=script&lang=js&"
export * from "./ChecklistAwardOngoingSurveyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports